import { BigintIsh } from '@hyperswap-labs/sdk-core'
import JSBI from 'jsbi'
import { Q96 } from '../internalConstants'

function maxLiquidityForAmount0(sqrtRatioAX96: JSBI, sqrtRatioBX96: JSBI, amount0: BigintIsh): JSBI {
  // Ensure sqrtRatioAX96 is less than sqrtRatioBX96
  const [lowerSqrtRatio, upperSqrtRatio] = JSBI.greaterThan(sqrtRatioAX96, sqrtRatioBX96)
    ? [sqrtRatioBX96, sqrtRatioAX96]
    : [sqrtRatioAX96, sqrtRatioBX96]

  // Calculate intermediate value
  const product = JSBI.multiply(lowerSqrtRatio, upperSqrtRatio)
  const intermediate = JSBI.divide(product, Q96)

  // Convert amount0 to JSBI if it isn't already
  const amount0JSBI = typeof amount0 === 'object' && 'toString' in amount0 ? amount0 : JSBI.BigInt(amount0)

  // Calculate final result
  const numerator = JSBI.multiply(amount0JSBI, intermediate)
  const denominator = JSBI.subtract(upperSqrtRatio, lowerSqrtRatio)

  return JSBI.divide(numerator, denominator)
}

function maxLiquidityForAmount1(sqrtRatioAX96: JSBI, sqrtRatioBX96: JSBI, amount1: BigintIsh): JSBI {
  // Ensure sqrtRatioAX96 is less than sqrtRatioBX96
  const [lowerSqrtRatio, upperSqrtRatio] = JSBI.greaterThan(sqrtRatioAX96, sqrtRatioBX96)
    ? [sqrtRatioBX96, sqrtRatioAX96]
    : [sqrtRatioAX96, sqrtRatioBX96]

  // Convert amount1 to JSBI if it isn't already
  const amount1JSBI = typeof amount1 === 'object' && 'toString' in amount1 ? amount1 : JSBI.BigInt(amount1)

  // Calculate numerator and denominator
  const numerator = JSBI.multiply(amount1JSBI, Q96)
  const denominator = JSBI.subtract(upperSqrtRatio, lowerSqrtRatio)

  return JSBI.divide(numerator, denominator)
}

/**
 * Computes the maximum amount of liquidity received for a given amount of token0, token1,
 * and the prices at the tick boundaries.
 * @param sqrtRatioCurrentX96 the current price
 * @param sqrtRatioAX96 price at lower boundary
 * @param sqrtRatioBX96 price at upper boundary
 * @param amount0 token0 amount
 * @param amount1 token1 amount
 */
export function maxLiquidityForAmounts(
  sqrtRatioCurrentX96: JSBI,
  sqrtRatioAX96: JSBI,
  sqrtRatioBX96: JSBI,
  amount0: BigintIsh,
  amount1: BigintIsh
): JSBI {
  if (JSBI.greaterThan(sqrtRatioAX96, sqrtRatioBX96)) {
    ;[sqrtRatioAX96, sqrtRatioBX96] = [sqrtRatioBX96, sqrtRatioAX96]
  }
  if (JSBI.lessThanOrEqual(sqrtRatioCurrentX96, sqrtRatioAX96)) {
    return maxLiquidityForAmount0(sqrtRatioAX96, sqrtRatioBX96, amount0)
  } else if (JSBI.lessThan(sqrtRatioCurrentX96, sqrtRatioBX96)) {
    const liquidity0 = maxLiquidityForAmount0(sqrtRatioCurrentX96, sqrtRatioBX96, amount0)
    const liquidity1 = maxLiquidityForAmount1(sqrtRatioAX96, sqrtRatioCurrentX96, amount1)
    return JSBI.lessThan(liquidity0, liquidity1) ? liquidity0 : liquidity1
  } else {
    return maxLiquidityForAmount1(sqrtRatioAX96, sqrtRatioBX96, amount1)
  }
}
